import styled from "styled-components";

const P = styled.p`
  font-size: 20px;
  padding: 0.5rem;
  margin: 0;
  max-width: 800px;
  text-align: justify;
`;

export default P;
